// 生日功能的共用判定。
// 與 client-pwa / client-pwa-cash 保持逐字相同的實作，任一邊調整需三邊同步
// （見 code-review/birthday-shared-spec.md）。

// 生日是否為 todayStr 當天。
// todayStr 為 'YYYY-MM-DD'，必須由站點時區產生（$dayjs），不可用裝置時區——
// 否則玩家改手機時區即可提前 / 延後觸發，與後端派發時區不一致。
// 規格：2/29 出生者平年歸 2/28、閏年只認 2/29（閏年的 2/28 不觸發）。
export const isBirthdayOn = (birthday, todayStr) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(birthday || '')) return false
  if (!/^\d{4}-\d{2}-\d{2}$/.test(todayStr || '')) return false

  const [, month, day] = birthday.split('-').map(Number)
  const [ty, tm, td] = todayStr.split('-').map(Number)
  const isLeapYear = (ty % 4 === 0 && ty % 100 !== 0) || ty % 400 === 0

  // 閏年時 targetDay 維持 29，故閏年的 2/28 不會相等，符合規格
  const targetDay = month === 2 && day === 29 && !isLeapYear ? 28 : day
  return tm === month && td === targetDay
}

// 生日獎勵的後端 remark 前綴。
// remark 格式為 '<key> <字串>'，但部分情況為純字串（無 key）——
// 故一律取第一個 token 比對白名單：純字串的第一個 token 不會命中，天然落空，
// 不需額外的例外分支。切勿改成整串完全比對（會讓 'key + 字串' 的情境失效）。
export const BIRTHDAY_REMARKS = ['birthday_reward', 'birthday_deposit_bonus']

export const isBirthdayRewardRemark = (remark) => BIRTHDAY_REMARKS.includes((remark || '').split(' ')[0])
